/**
 * @file 加盟員検索モーダルの検索ボタン
 */
'use strict'

import TableSetStickyColumns from "../Basic/TableSetStickyColumns"
import SelectMemberFromMemberSearchModal from "./SelectMemberFromMemberSearchModal"

/**
 * @classname BtnMemberSearch
 * @classdesc 加盟員検索モーダルの検索ボタン
 */
export default class BtnMemberSearch {
	/**
	 * @constructor
	 * @param {jQuery} $e - $('.btn-member-search')
	 * @param {instance} controller
	 */
	constructor($e, controller) {
		console.log('BtnMemberSearch.constructor')
		this._$e = $e
		this._controller = controller
		this._$formControls = this._$e.closest('.modal-body').find('.form-control')
		this._$info = this._$e.closest('.modal-body').find('.result-information')
		this._$table = this._$e.closest('.modal-body').find('.table')
		this._$responseNamesWrap = this._$e.closest('.modal-body').find('.response-names-wrap')
		this._$e.on('click', () => this.onClick())
		this._controller.on('searchMemberComplete', () => this.onSearchMemberComplete())
	}


	/**
	 * Template: thead
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	getTheadTemplate() {
		return `
<thead class="thead">
	<tr class="tr">
		<th class="th">ユーザーID</th>
		<th class="th">加盟員No</th>
		<th class="th">氏名</th>
		<th class="th">氏名カナ</th>
		<th class="th">連盟</th>
		<th class="th">地区</th>
		<th class="th">団</th>
		<th class="th">所属・隊</th>
		<th class="th">役務</th>
		<th class="th">個人共済履歴</th>
		<th class="th">選択</th>
	</tr>
</thead>`
	}


	/**
	 * Template: tbody
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	getTbodyTemplate() {
		return `<tbody class="tbody"></tbody>`
	}


	/**
	 * Template: エラーメッセージ
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	getResultInformationTemplate(type) {
		switch (type) {
			case 'none':
				return `<div class="fade show alert alert-warning alert-dismissible">該当する情報はありません。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>`
			case 'over':
				return `<div class="fade show alert alert-warning alert-dismissible">検索結果が250件を超えたため、250件目までを表示しています。<button class="close" type="button" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">×</span></button></div>`
		}
	}


	/**
	 * クリックのコールバック
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	onClick() {
		console.log('BtnMemberSearch.onClick')
		this._$info.html('')
		this._$table.html('').append($(this.getTheadTemplate())).append($(this.getTbodyTemplate()))
		this._controller.searchMember(this.getSubmitValues())
	}


	/**
	 * 送信する値を取得
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	getSubmitValues() {
		console.log('BtnMemberSearch.getSubmitValues')
		let submitValues = {}
		this._$formControls.each((_, element) => submitValues[$(element).data('search-item')] = $(element).val())
		return submitValues
	}


	/**
	 * 検索完了時コールバック
	 *
	 * @memberof BtnMemberSearch
	 * @return {undefined}
	 */
	onSearchMemberComplete() {
		console.log('BtnMemberSearch.onSearchMemberComplete')
		console.log(this._controller._memberCount)
		if (this._controller._memberCount == 0) {
			this._$info.append(this.getResultInformationTemplate('none'))
		} else {
			console.log(this._controller._members)
			if (250 < this._controller._memberCount) this._$info.append(this.getResultInformationTemplate('over'))
			this._controller._members.forEach((member, index) => this._$table.find('tbody').append(this.generateTableRow(member, index)))
			new TableSetStickyColumns(this._$table)
		}
	}


	/**
	 * 反映する値を取得
	 *
	 * @memberof BtnMemberSearch
	 * @return {string}
	 */
	getSettingValue(data, index) {
		console.log('BtnMemberSearch.getResponseName')
		const name = this._$responseNamesWrap.find(`[data-index='${index}']`).data('response-name')
		return name.match(/\:/) ? `${data[name.split(':')[0]]} ${data[name.split(':')[1]]}` : data[name]
	}


	/**
	 * テーブルの行を生成
	 *
	 * @memberof BtnMemberSearch
	 * @return {$row} - HTML
	 */
	generateTableRow(member, index) {
		console.log('BtnMemberSearch.generateTableRow')
		console.log(member, index)
		let $row = $(`
<tr class="tr">
	<td class="td">${this.getSettingValue(member, 0)}</td>
	<td class="td">${this.getSettingValue(member, 1)}</td>
	<td class="td">${this.getSettingValue(member, 2)}</td>
	<td class="td">${this.getSettingValue(member, 3)}</td>
	<td class="td">${this.getSettingValue(member, 4)}</td>
	<td class="td">${this.getSettingValue(member, 5)}</td>
	<td class="td">${this.getSettingValue(member, 6)}</td>
	<td class="td">${this.getSettingValue(member, 7)}</td>
	<td class="td">${this.getSettingValue(member, 8)}</td>
</tr>`)
		{
			const $button = $(document.createElement('button'))
			$button.attr('type', 'button').addClass('btn btn-success btn-sm').text('参照')
			$button.on('click', () => window.open(`${window.const.STATIC_URL.INDIVIDUAL_MUTUAL_AID_HISTORY}?user_profile_id=${this.getSettingValue(member, 0)}`, '_blank'))
			const $td = $(document.createElement('td'))
			$td.addClass('td tac').append($button)
			$row.append($td)
		}
		{
			const $button = $(document.createElement('button'))
			$button.attr({ type: 'button', 'data-index': index, 'data-user-id': this.getSettingValue(member, 0) }).addClass('btn btn-success btn-sm').text('選択')
			new SelectMemberFromMemberSearchModal($button, this._controller)
			const $td = $(document.createElement('td'))
			$td.addClass('td tac').append($button)
			$row.append($td)
		}
		return $row
	}
}
